module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-body__wrap"
  }, [_c('cart-items', {
    attrs: {
      "custom-class": 'cb-body__content'
    }
  }), _vm._v(" "), (!_vm.editMode) ? _c('div', {
    staticClass: "cb-body__footer"
  }, [_c('estimate-fixed', {
    attrs: {
      "edit-order": _vm.editMode,
      "from-cart": true
    }
  }), _vm._v(" "), _c('button-field', {
    attrs: {
      "attr": 'cart_submit',
      "custom-class": 'primary',
      "showLoader": _vm.showLoader
    },
    on: {
      "next": _vm.next
    }
  }, [_vm._v("\n      " + _vm._s(_vm.t('cart.next')) + " "), _c('i', {
    staticClass: "icon-long-arrow-right"
  })])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77f436f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/checkout/CartNew.vue
// module id = 607
// module chunks = 66